export default "__VITE_ASSET__BiLWWqHU__"